export default __webpack_public_path__ + "static/media/product6.347ff17c.png";